import React, { Component } from 'react';
import './Chart5.css';
import { chartFactory } from './../../lib/alpha_chart.js';
import $ from 'jquery';
import { getTRDecimalPlace } from './../../lib/utils'
import i18next from 'i18next';
import axios from 'axios'

export default class Chart5 extends Component<any, any> {

  container: any
  chartpane: any
  canvasbox: any
  scrollpane: any
  scrollcanvasbox: any
  $chartframeobj: any
  mainchartobj: any
  scrollcharobj: any
  compseries: any
  series: any
  tachartobj: any

  constructor(props: any) {
    super(props);
    this.container = React.createRef();
    this.chartpane = React.createRef();
    this.scrollpane = React.createRef();
    this.state = {
      haveChart: true
    }
  }

  componentDidMount() {
    this.$chartframeobj = chartFactory.create();
    let w = this.container.current.clientWidth;
    let h = this.container.current.clientHeight;

    let options = {};
    if (!this.props.noCrosshair) options = { tooltipFunc: this.tooltipFunc, dateRangeFunc: this.dateRangeFunc };
    this.mainchartobj = this.$chartframeobj.add(chartFactory.PRICE_CHART, 'mainchart', w, h, $(this.refs.canvasbox), options, 1);
    this.mainchartobj.shrink(0.1);

    this.scrollcharobj = this.$chartframeobj.add(chartFactory.CONDENSE_CHART, 'scrollchart', w, h * 0.4, $(this.refs.scrollcanvasbox));

    if (this.props.noCrosshair)
      this.mainchartobj.setCrosshairStyle();
    this.renderChart(this.props);
  }

  componentWillReceiveProps(nextProps: any) {

    this.setState({ mainTooltip: '' });

    if (this.props.ccy === nextProps.ccy && this.props.period === nextProps.period && this.props.compare === nextProps.compare
      && this.props.type === nextProps.type
      && this.props.overlay === nextProps.overlay && this.props.overlayConfig === nextProps.overlayConfig
      && this.props.tapane === nextProps.tapane && this.props.tapaneConfig === nextProps.tapaneConfig) {
      setTimeout(() => { this.resizeChart(nextProps); }, 100);
      return;
    }

    if (this.props.ccy === nextProps.ccy && this.props.period === nextProps.period) {
      this.updateChart(nextProps);
    } else {
      if (this.props.tapane) {
        this.removeTAPane(this.props.tapane);
      }

      this.renderChart(nextProps);
    }
  }

  resizeChart = (props: any) => {

    if (props === '')
      props = this.props

    let TA_PANE = ['RSI', 'MACD', 'SKD', 'FKD'];

    if (this.container && this.container.current) {
      if (this.$chartframeobj.charts.length > 1 && TA_PANE.includes(props.tapane) && props.compare === '')
        this.mainchartobj.setGridStyle(chartFactory.GRID_LABEL_Y);
      else
        this.mainchartobj.setGridStyle(chartFactory.GRID_LABEL_X | chartFactory.GRID_LABEL_Y);

      this.mainchartobj.resize(1, 1);

      let w = this.container.current.clientWidth;
      let h = this.container.current.clientHeight;

      if (props.compare === '' && props.tapane && TA_PANE.includes(props.tapane)) {
        this.mainchartobj.resize(w, h - 100);
      } else {
        this.mainchartobj.resize(w, h);
      }

      if (this.$chartframeobj.charts.length > 1)
        this.$chartframeobj.charts[1].resize(w, 100);
    }
  }

  removeOverLay(ta: string) {
    let ids = [];
    let drawers = this.mainchartobj.drawers;
    switch (ta) {
      case "SMA":
        for (let i = 0; i < drawers.length; i++) {
          if (drawers[i].obj.name.startsWith(chartFactory.SMA))
            ids.push(drawers[i].obj.name);
        }

        for (let i = 0; i < ids.length; i++) {
          this.mainchartobj.removeDrawer(ids[i]);
        }
        break;

      case "BB":
        for (let i = 0; i < drawers.length; i++) {
          if (drawers[i].obj.name.startsWith(chartFactory.BOLLINGERBANDS))
            ids.push(drawers[i].obj.name);
        }
        for (let i = 0; i < ids.length; i++) {
          this.mainchartobj.removeDrawer(ids[i]);
        }
        break;

      case "SAR":
        this.mainchartobj.removeDrawer(chartFactory.SAR);
        break;

      case "nooverlay":
      default:
        break;
    }
  }

  removeTAPane(ta: string) {
    switch (ta) {
      case "RSI":
        this.$chartframeobj.remove(chartFactory.RSI);
        break;

      case "MACD":
        this.$chartframeobj.remove(chartFactory.MACD);
        break;

      case "SKD":
        this.$chartframeobj.remove(chartFactory.STOCHASTIC_SLOW);
        break;

      case "FKD":
        this.$chartframeobj.remove(chartFactory.STOCHASTIC_FAST);
        break;

      case "notapane":
      default:
        break;
    }
  }

  updateChart(nextProps: any) {
    this.setState({ mainTooltip: undefined, TATooltip: undefined });
    switch (this.props.type) {
      case "candlestick": this.mainchartobj.removeCandlestick(); break;
      case "bar": this.mainchartobj.removeOHLC(); break;
      case "line": this.mainchartobj.removeLine(); break;
      default: break;
    }

    if (this.props.overlay) {
      this.removeOverLay(this.props.overlay);
    }

    if (this.props.tapane) {
      this.removeTAPane(this.props.tapane);
    }

    if (this.props.compare && this.props.compare !== nextProps.compare) {
      this.mainchartobj.drawers[0].obj.removeSeries(this.compseries);

      if (!nextProps.compare) {
        this.mainchartobj.removeBaseComparison();
        this.series.decimalPlace = 5;
      }
    }

    if (nextProps.type === 'candlestick') {
      let style = {
        upColor: '#FF0000',
        upFillColor: '#FF0000',
        downColor: '#00FF00',
        downFillColor: '#00FF00'
      };
      this.mainchartobj.addCandlestick2(style, 1);
    } else if (nextProps.type === 'bar') {
      let styleobj = {
        upColor: "#00a546", //--upcolor
        downColor: "#d0021b"  //--downcolor
      };
      this.mainchartobj.addOHLC2(styleobj, 1);
    } else {
      let styleobj = {
        color: "#B71F29", //--digital-blue
        fillColor: "#F7E8E9",
        fillColor2: "#FFFFFF",
        thickness: 2,
        style: 0
      };
      this.mainchartobj.addLine2(styleobj, 1);
    }

    if (nextProps.compare !== '') {
      this.mainchartobj.addBaseComparison2(100, {
        color: '#B71F29',
        thickness: 2,
      });

      this.addComparison(nextProps);

    } else {
      this.series.decimalPlace = 5;
      if (nextProps.overlay) {
        this.addOverlayTA(nextProps, nextProps.overlay)
      }

      if (nextProps.tapane) {
        this.addTAPane(nextProps, nextProps.tapane)
      }
    }

    this.resizeChart(nextProps);
  }

  renderChart = (props: any) => {
    this.setState({ mainTooltip: undefined, TATooltip: undefined });
    let i = 'd';
    let api = 'hts';
    let dataType = chartFactory.HTS_DATA;
    let gridType = chartFactory.GRID_DATE_ALIGN;
    switch (props.period) {
      case '1D': i = '1'; api = 'mts'; dataType = chartFactory.MTS_DATA; gridType = chartFactory.GRID_TIME_ALIGN; break;
      case '3Y': i = 'w'; break;
      default: break;
    }

    this.mainchartobj.setGridType(gridType);

    let url = this.props.domain + '/bochkfxwidget/data/' + api + '?fx=' + props.ccy + '&i=' + i + '&token=' + this.props.token + '&_=' + new Date().getTime();
    this.series = this.$chartframeobj.data(dataType, props.ccy, url, { successFunc: this.dataReady, decimalPlace: getTRDecimalPlace(props.ccy) });
    this.mainchartobj.data(this.series);
    this.series.open();

    //scrollpane
    this.scrollcharobj.data(this.series);

    if (props.type === 'candlestick') {
      let style = {
        upColor: '#FF0000',
        upFillColor: '#FF0000',
        downColor: '#00FF00',
        downFillColor: '#00FF00'
      };
      this.mainchartobj.addCandlestick2(style, 1);
    } else if (props.type === 'bar') {
      let styleobj = {
        upColor: "#00a546", //--upcolor
        downColor: "#d0021b"  //--downcolor
      };
      this.mainchartobj.addOHLC2(styleobj, 1);
    } else {
      let styleobj = {
        color: "#B71F29", //--digital-blue
        fillColor: "#F7E8E9",
        fillColor2: "#FFFFFF",
        thickness: 2,
        style: 0
      };
      this.mainchartobj.addLine2(styleobj, 1);
    }

    if (props.compare === '') {
      this.series.decimalPlace = 5;
      if (props.overlay) {
        this.addOverlayTA(props, props.overlay);
      }
      if (props.tapane) {
        this.addTAPane(props, props.tapane);
      }
    }
    else {
      this.mainchartobj.addBaseComparison2(100, {
        color: '#B71F29',
        thickness: 2,
        // style: params.style,
        // blazeColor: '#'+stylesetting.chdot.color0,
        // blazeRadius: stylesetting.chdot.thickness
      });

      this.addComparison(props);
    }

    this.resizeChart(props);
  }

  addComparison(props: any) {

    switch (props.type) {
      case "candlestick": this.mainchartobj.removeCandlestick(); break;
      case "bar": this.mainchartobj.removeOHLC(); break;
      case "line": this.mainchartobj.removeLine(); break;
      default: break;
    }

    let i = 'd';
    let api = 'hts';
    let dataType = chartFactory.HTS_DATA;
    // let gridType = chartFactory.GRID_DATE_ALIGN;
    switch (props.period) {
      case '1D': i = '1'; api = 'mts'; dataType = chartFactory.MTS_DATA;
        //  gridType = chartFactory.GRID_TIME_ALIGN; 
        break;
      case '3Y': i = 'w'; break;
      default: break;
    }
    // this.mainchartobj.setGridType(gridType);
    //let domain = process.env.NODE_ENV === 'production' ? '' : "https://t9.trkd-hs.com/bochkfxwidget/";

    //For develop
    const token = ""
    let url = this.props.domain + '/bochkfxwidget/data/' + api + '?fx=' + props.compare + '&i=' + i + '&token=' + this.props.token + '&_=' + new Date().getTime();

    //let url = domain + 'data/' + api + '?fx=' + props.compare + '&i=' + i + '&token=' + decodeURIComponent(axios.defaults.headers.common['token']) + '&_=' + new Date().getTime();
    this.compseries = this.$chartframeobj.data(dataType, props.compare, url, { successFunc: this.dataReady2, decimalPlace: 2 });
    this.compseries.open();

    this.series.decimalPlace = 2;
  }

  dataReady2 = () => {
    this.mainchartobj.drawers[0].obj.addSeries2(this.compseries, {
      color: '#EF7B22',
      thickness: 2,
    });

    this.dataReady();
  }

  addOverlayTA(props: any, ta: string) {
    switch (ta) {
      case 'SMA':
        if (props.overlayConfig.p1) {
          this.mainchartobj.addSMA({
            period: props.overlayConfig.p1,
            color: "#d0021b",
            thickness: 2,
            style: 0
          }, 100);
        }

        if (props.overlayConfig.p2) {
          this.mainchartobj.addSMA({
            period: props.overlayConfig.p2,
            color: "#FFB0B0",
            thickness: 2,
            style: 0
          }, 100);
        }

        if (props.overlayConfig.p3) {
          this.mainchartobj.addSMA({
            period: props.overlayConfig.p3,
            color: "#449999",
            thickness: 2,
            style: 0
          }, 100);
        }
        break;
      case 'BB':
        if (props.overlayConfig.p) {
          this.mainchartobj.addBollinger({
            period: props.overlayConfig.p,
            deviation: {
              value: 2,
              color0: "#0091ea",
              color1: "#d0021b",
              thickness: 2,
              style: 0
            }
          }, 100);

          this.mainchartobj.addBollinger({
            period: props.overlayConfig.p,
            color: "#555555",
            thickness: 1,
            style: "d"
          }, 100);
        }
        break;
      case 'SAR':
        this.mainchartobj.addSAR({
          color: "#d0021b",
          factor: {
            def: 0.02,
            inc: 0.02,
            max: 0.2
          }
        }, 100);
        break;
      default:
        break;
    }
  }

  getMainChartOptions() {
    return {
      gridType: this.mainchartobj.gridType,
      gridStyle: this.mainchartobj.gridStyle,
      crosshairStyle: this.mainchartobj.crosshairStyle,
      crosshairFunc: this.mainchartobj.crosshairFunc,
      tooltipFunc: this.mainchartobj.tooltipFunc,
      dateRangeFunc: this.mainchartobj.dateRangeFunc
    };
  }

  addTAPane(props: any, ta: string) {
    if (!this.mainchartobj) return;

    let w = this.container.current.clientWidth;
    let h = 100;
    switch (ta) {
      case 'RSI':
        if (props.tapaneConfig.p) {
          this.tachartobj = this.$chartframeobj.add(chartFactory.PRICE_CHART, chartFactory.RSI, w, h, $(this.refs.canvasbox), this.getMainChartOptions(), 100);
          this.tachartobj.data(this.mainchartobj.series);

          this.tachartobj.addPriceTracker2("lowerRSI", 25, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("upperRSI", 75, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("y50", 50, { color: "#EEEEEE", textColor: "#333333", invertColor: '#FFFFFF', dash: 0 });
          this.tachartobj.fixedScale(0, 100);
          this.tachartobj.setGridStyle(chartFactory.GRID_LABEL_X | chartFactory.GRID_LABEL_Y);
          this.tachartobj.addRSI({
            method: chartFactory.MA_EMA,
            period: props.tapaneConfig.p,
            color: "#00a546", //--stanchart-green
            thickness: 2,
            style: 0
          });
          this.tachartobj.show(this.mainchartobj);
        }
        break;

      case 'MACD':
        if (props.tapaneConfig) {
          let p1 = props.tapaneConfig.fast;
          let p2 = props.tapaneConfig.slow;
          let p = props.tapaneConfig.signal;
          this.tachartobj = this.$chartframeobj.add(chartFactory.PRICE_CHART, chartFactory.MACD, w, h, $(this.refs.canvasbox), this.getMainChartOptions(), 100);
          this.tachartobj.setGridStyle(chartFactory.GRID_LABEL_X | chartFactory.GRID_LABEL_Y);
          this.tachartobj.data(this.mainchartobj.series);

          this.tachartobj.addMACD({
            macd: {
              period: p1,
              period2: p2,
              color: "#d0021b",
              thickness: 2,
              style: 0
            },
            signal: {
              period: p,
              color: "#555555",
              thickness: 2,
              style: 0
            },
            hist: {
              posColor: "#0091ea",
              negColor: "#d0021b"
            }
          });
          this.tachartobj.show(this.mainchartobj);
        }
        break;

      case 'SKD':
        if (props.tapaneConfig) {
          let ps = props.tapaneConfig.k;
          let ps1 = props.tapaneConfig.d;
          this.tachartobj = this.$chartframeobj.add(chartFactory.PRICE_CHART, chartFactory.STOCHASTIC_SLOW, w, h, $(this.refs.canvasbox), this.getMainChartOptions(), 100);
          this.tachartobj.setGridStyle(chartFactory.GRID_LABEL_X);
          this.tachartobj.data(this.mainchartobj.series);

          this.tachartobj.addPriceTracker2("lowerSKD", 25, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("upperSKD", 75, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("y50", 50, { color: "#EEEEEE", textColor: "#333333", invertColor: '#FFFFFF', dash: 0 });
          this.tachartobj.fixedScale(0, 100);
          this.tachartobj.addStochastic({
            method: chartFactory.MA_SMA,
            periodK: ps,
            colorK: "#d0021b",
            thicknessK: 2,
            styleK: 0,
            periodD: ps1,
            periodF: 3,
            colorD: "#0080FF",
            thicknessD: 2,
            styleD: 0
          });
          this.tachartobj.show(this.mainchartobj);
        }
        break;

      case 'FKD':
        if (props.tapaneConfig) {
          let pf = props.tapaneConfig.k;
          let pf1 = props.tapaneConfig.d;
          this.tachartobj = this.$chartframeobj.add(chartFactory.PRICE_CHART, chartFactory.STOCHASTIC_FAST, w, h, $(this.refs.canvasbox), this.getMainChartOptions(), 100);
          this.tachartobj.setGridStyle(chartFactory.GRID_LABEL_X);
          this.tachartobj.data(this.mainchartobj.series);

          this.tachartobj.addPriceTracker2("lowerFKD", 25, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("upperFKD", 75, { color: "#000080", textColor: "#333333", invertColor: '#FFFFFF', dashstyle: chartFactory.TRACKER_DASH });
          this.tachartobj.addPriceTracker2("y50", 50, { color: "#EEEEEE", textColor: "#333333", invertColor: '#FFFFFF', dash: 0 });
          this.tachartobj.fixedScale(0, 100);
          this.tachartobj.addFastStochastic({
            method: chartFactory.MA_SMA,
            periodK: pf,
            colorK: "#d0021b",
            thicknessK: 2,
            styleK: 0,
            periodD: pf1,
            periodF: 3,
            colorD: "#0080FF",
            thicknessD: 2,
            styleD: 0
          });
          this.tachartobj.show(this.mainchartobj);
        }
        break;

      default:
        break;
    }

  }

  dataReady = () => {
    let fr = new Date();
    let to = new Date();

    switch (this.props.period) {
      case "1D": fr.setDate(fr.getDate() - 1); break;
      case "1W": fr.setDate(fr.getDate() - 7); break;
      case "1M": fr.setMonth(fr.getMonth() - 1); break;
      case "3M": fr.setMonth(fr.getMonth() - 3); break;
      case "6M": fr.setMonth(fr.getMonth() - 6); break;
      case "1Y": fr.setFullYear(fr.getFullYear() - 1); break;
      case "3Y": fr.setFullYear(fr.getFullYear() - 3); break;
      default: break;
    }

    if (this.series.spotCount !== undefined) {
      let spotCount = this.series.spotCount 
      if (spotCount > 0) {
        this.setState({ haveChart: true })
      } else {
        this.setState({ haveChart: false })
      }
    }

    this.mainchartobj.show(fr, to);
    if (this.tachartobj)
      this.tachartobj.show(fr, to);

    //scrollpane
    if (this.props.period === '1D') {
      this.scrollcharobj.setGridType(chartFactory.GRID_TIME_ALIGN)
    }
    else
      this.scrollcharobj.setGridType(chartFactory.GRID_DATE_EVEN)

    this.scrollcharobj.show(this.mainchartobj);
  }

  formatDate(date: Date) {
    if (date) {
      let out = date.toLocaleString("en-us", { day: '2-digit' }) + '/' + date.toLocaleString("en-us", { month: '2-digit' }) + '/' + date.toLocaleString("en-us", { year: '2-digit' });

      if (this.props.period === '1D')
        out += ' ' + date.toLocaleString("en-GB", { hour: '2-digit', minute: '2-digit' });

      return out;
    }
  }

  tooltipFunc = (res: any) => {
    let w = this.container.current.clientWidth;
    if (this.props.compare === '') {
      if (res.open) {
        let tt;
        if (w < 400)
          tt = <span>{i18next.t('Chart.Date', '')}: <b>{this.formatDate(res.date)}</b> {i18next.t('Chart.Close', '')}: <b>{res.close}</b><br />{i18next.t('Chart.Open', '')}: <b>{res.open}</b> {i18next.t('Chart.High', '')}: <b>{res.high}</b> {i18next.t('Chart.Low', '')}: <b>{res.low}</b></span>
        else {
          tt = <span>{i18next.t('Chart.Date', '')}: <b>{this.formatDate(res.date)}</b> {i18next.t('Chart.Close', '')}: <b>{res.close}</b> {i18next.t('Chart.Open', '')}: <b>{res.open}</b> {i18next.t('Chart.High', '')}: <b>{res.high}</b> {i18next.t('Chart.Low', '')}: <b>{res.low}</b></span>

          let overlay;
          if (this.props.overlay === 'SMA') {
            let sma0 = res["SMA_" + this.props.overlayConfig.p1],
              sma1 = res["SMA_" + this.props.overlayConfig.p2],
              sma2 = res["SMA_" + this.props.overlayConfig.p3];
            overlay = <span><b>{i18next.t('Chart.TA.SMA', '')}</b> {this.props.overlayConfig.p1},{this.props.overlayConfig.p2},{this.props.overlayConfig.p3}: <span style={{ color: '#d0021b' }}><b>{sma0}</b> ({this.props.overlayConfig.p1})</span> <span style={{ color: '#FFB0B0' }}><b>{sma1}</b> ({this.props.overlayConfig.p2})</span> <span style={{ color: '#449999' }}><b>{sma2}</b> ({this.props.overlayConfig.p3})</span></span>;
          }
          else if (this.props.overlay === 'BB') {
            let bb = res["BB_" + this.props.overlayConfig.p + "_2"];
            overlay = <span><b>{i18next.t('Chart.TA.BB', '')}</b> {this.props.overlayConfig.p},2σ: <span style={{ color: '#555555' }}><b>MA {bb.m}</b> ({this.props.overlayConfig.p})</span> <b>2σ</b> <span style={{ color: '#0091ea' }}><b>{bb.u}</b> (UB)</span> <span style={{ color: '#d0021b' }}><b>{bb.l}</b> (LB)</span></span>

          }

          if (overlay) {
            tt = <span>{tt}<br />{overlay}</span>
          }
        }
        this.setState({ mainTooltip: tt });
      } else {
        let tt;
        if (this.props.tapane === 'RSI') {
          if (w < 400)
            tt = <span><b>{i18next.t('Chart.TA.RSI', '')}</b> EMA-{this.props.tapaneConfig.p}</span>
          else
            tt = <span><b>{i18next.t('Chart.TA.RSI', '')}</b> EMA-{this.props.tapaneConfig.p}: <span style={{ color: '#00a546' }}><b>{res['RSI_2_' + this.props.tapaneConfig.p]}</b> </span></span>
        }
        else if (this.props.tapane === 'MACD') {
          if (w < 400)
            tt = <span><b>{i18next.t('Chart.TA.MACD', '')}</b>{this.props.tapaneConfig.fast},{this.props.tapaneConfig.slow},{this.props.tapaneConfig.signal}</span>
          else
            tt = <span><b>{i18next.t('Chart.TA.MACD', '')}</b>{this.props.tapaneConfig.fast},{this.props.tapaneConfig.slow},{this.props.tapaneConfig.signal} <span style={{ color: '#D0021B' }}><b>{res.macd}</b> (MACD)</span> <span style={{ color: '#555555' }}><b>{res.signal}</b> ({i18next.t('Chart.Signal', '')})</span> <span><b>{res.histogram}</b> (Osc)</span></span>
        }
        else if (this.props.tapane === 'SKD') {
          if (w < 400)
            tt = <span><b>{i18next.t('Chart.TA.SKD', '')}</b> SMA,{this.props.tapaneConfig.k},{this.props.tapaneConfig.d}</span>
          else
            tt = <span><b>{i18next.t('Chart.TA.SKD', '')}</b> SMA,{this.props.tapaneConfig.k},{this.props.tapaneConfig.d}: <span style={{ color: '#d0021b' }}><b>%K {res.pctK}</b></span> <span style={{ color: '#0080FF' }}><b>%D {res.pctD}</b></span></span>
        }
        else if (this.props.tapane === 'FKD') {
          if (w < 400)
            tt = <span><b>{i18next.t('Chart.TA.FKD', '')}</b> SMA,{this.props.tapaneConfig.k},{this.props.tapaneConfig.d}</span>
          else
            tt = <span><b>{i18next.t('Chart.TA.FKD', '')}</b> SMA,{this.props.tapaneConfig.k},{this.props.tapaneConfig.d}: <span style={{ color: '#d0021b' }}><b>%K {res.pctK}</b></span> <span style={{ color: '#0080FF' }}><b>%D {res.pctD}</b></span></span>
        }
        this.setState({ TATooltip: tt });
      }
    } else {
      let tt;
      tt = <span><div style={{ color: '#B71F29' }}>{i18next.t('Chart.Currency', '')}: <b>{this.props.ccynm}</b></div><div style={{ color: '#EF7b22' }}>{i18next.t('Chart.Compare', '')}: <b>{this.props.comparenm}</b></div></span>
      this.setState({ mainTooltip: tt });
    }
  }

  dateRangeFunc = (from: any, to: any) => {
    let tt;
    tt = <span>{i18next.t('Chart.Date', '')}: <b>{this.formatDate(from)} ~ {this.formatDate(to)}</b></span>
    this.setState({ scrollpaneTooltip: tt });
  }

  zoomIn = () => {
    const endIndex = this.mainchartobj.axisX.endIndex - 100
    const newIndex = this.mainchartobj.axisX.startIndex + 100

    if (newIndex < endIndex) {
      this.mainchartobj.viewZoomX(this.mainchartobj.axisX.startIndex += 100, this.mainchartobj.axisX.endIndex)
      this.scrollcharobj.viewZoomX(this.mainchartobj.axisX.startIndex += 100, this.mainchartobj.axisX.endIndex)
    }

    this.updateChart(this.props)
  }

  zoomOut = () => {
    if (this.mainchartobj.axisX.startIndex - 100 > 0) {
      this.mainchartobj.viewZoomX(this.mainchartobj.axisX.startIndex -= 100, this.mainchartobj.axisX.endIndex)
      this.scrollcharobj.viewZoomX(this.mainchartobj.axisX.startIndex -= 100, this.mainchartobj.axisX.endIndex)
    } else {
      this.mainchartobj.viewZoomX(this.mainchartobj.axisX.startIndex -= this.mainchartobj.axisX.startIndex - 1, this.mainchartobj.axisX.endIndex)
      this.scrollcharobj.viewZoomX(this.mainchartobj.axisX.startIndex -= this.mainchartobj.axisX.startIndex - 1, this.mainchartobj.axisX.endIndex)
    }

    this.updateChart(this.props)
  }

  render() {

    return (
      <div className="Chart5" style={{ fontSize: this.props.fontsize }} ref={this.container}>
        <div style={!this.state.haveChart ? { fontSize: '1rem', fontWeight: 'bold', marginLeft: '1rem', marginTop: '90px' } : { display: 'none' }}>{i18next.t("Chart.Error", "")}</div>
        <div className='Chart5-MainTooltip' >{this.state.mainTooltip}</div>
        <div className='Chart5-TATooltip'>{this.state.TATooltip}</div>
        <div className="chartpane" ref={this.chartpane}>
          <div className="canvasbox" ref='canvasbox'></div>
        </div>
        {
          this.props.enableScrollPane &&
          <div className="scrollpane" ref={this.scrollpane}>
            <div className='scrollpane-ScrollTooltip'>{this.state.scrollpaneTooltip}</div>
            <div className="scrollcanvasbox" ref='scrollcanvasbox'></div>
          </div>
        }
      </div>
    );
  }
}
